// client/src/App.js

import React from "react";
import logo from "../logo.svg";
import "../App.css";
import CommonContext from '../commonContext';
import { postCall } from '../utils/requests';
import {
  Box,
  Center,
  Text,
  Flex,
  HStack,
  VStack,
  Stack,
  UnorderedList,
  ListItem,
  Button
} from '@chakra-ui/react';
import { BiArrowBack } from "react-icons/bi";
import HomeTile from '../components/HomeTile';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { IoNotificationsSharp } from "react-icons/io5";
import { IoMdNotificationsOutline } from "react-icons/io";
import { GrInProgress } from "react-icons/gr";
import { utilConstants } from '../utils/utilConstants';

function HomePage() {
  const [data, setData] = React.useState(null);
  const commonContext = React.useContext(CommonContext);

  React.useEffect(() => {

    commonContext.setCurrentPath("Home")
    commonContext.setCurrentPage("home")

  }, []);


  /* BEGIN - TEST */

  const sendNotification = async () => {
    console.log("send notification")
    const resp = await postCall("/notifyToken", {
      imageUrl: "",
      iconUrl: "",
      title: "test title",
      message: "test message",
      token: "cND8ocGOQEy69YLW0e5FF-:APA91bGaJwwNAMh4WCWmFu5qCZd6VmZtLo0MxwwcNykEgYT3dD48Af3KvhQK3ggnPSD7DVqxdAz6CmHaz9ETeOWZe3pecduI5_T_hj8H-HiwYXnWMtp8iX_4Sa8DL-Op46HFd4R1a1JY"
    })

    console.log("resp", resp)
    /* .then((data) => {

      console.log("notification sent")

      console.log(data)
    }) */

  }

  /* END - TEST */



  /* Notifications component */

  function Notifications() {

    return (
      <Center w="100%" h="80%">
        <Stack>
          <Text fontSize="xl" textAlign="center">Nessuna nuova notifica</Text>
{/*           <Text fontSize="sm" textAlign="center">(funzionalità in sviluppo)</Text>
          <Button onClick={sendNotification} mr={3}>Send notification</Button>
 */}
        </Stack>
      </Center>
    );
  }

  function Development() {

    return (
      <Center pl="40px" pr="40px" w="100%" h="80%">
        <Stack >
          <Text mb="30px" fontSize="lg" textAlign="center">Versione: {utilConstants.version}</Text>
          <Text mb="20px" fontSize="xl" textAlign="center">Ultime funzionalità aggiunte:</Text>
          <Text fontSize="md" textAlign="center">- Gestione Palmares</Text>
          <Text mb="20px" fontSize="xl" textAlign="center">Prossime funzionalità:</Text>
          <Text fontSize="md" textAlign="center">- Visualizzazione feedback utenti</Text>
        </Stack>
      </Center>
    );
  }


  return (
    <Box p="4">

      <div className="App-body">
        <Flex mr="5%" ml="5%" justifyContent="space-between">
          <HomeTile
            title="Notifiche"
            content={<Notifications />}
            icon={<IoMdNotificationsOutline size={35} />}
            onClick={() => {
              console.log("CLICKED")
            }}
            width="45%"
            height="500px"
          />
          <HomeTile
            bg="green.300"
            title="Log di sviluppo"
            content={<Development />}
            icon={<GrInProgress size={30} />}
            onClick={() => {
              console.log("CLICKED")
            }}
            width="45%"
            height="500px"
          />

        </Flex>

      </div>
    </Box>
  );
}

export default HomePage;